/* eslint-disable no-useless-constructor */
/* global DeferredMedia */

if (!customElements.get("product-model")) {
  class ProductModel extends DeferredMedia {
    constructor() {
      super();
      this.init();
    }

    init() {
      let startX,
        startY,
        isMouseDown = false;

      this.addEventListener("mousedown", (event) => {
        startX = event.clientX;
        startY = event.clientY;
        isMouseDown = true;
      });

      this.addEventListener("mouseup", (event) => {
        if (isMouseDown) {
          const endX = event.clientX;
          const endY = event.clientY;

          if (startX == endX && startY === endY) {
            const modelViwer = this.querySelector("model-viewer");
            const picture = this.querySelector("picture");
            const featuted = document.querySelector('.media-viewer__item.is-current-variant .featured-image-product')
            const img3d = document.querySelector('.img-3d')
            const img3dButton = document.querySelector('.img-3d .media-poster')
            const viewerUi = document.querySelector('.shopify-model-viewer-ui')
            const closeImg3d = document.querySelector('.close-img3d')
            const divModel = document.querySelector('.shopify-model-viewer-ui shopify-model-viewer-ui--desktop')

            function close3d() {
              console.log('closeimg3d')
              closeImg3d.addEventListener("click", () => {
                console.log('click closeimg3d')
                modelViwer.style.display = "none";
                viewerUi.style.display = "none";
                viewerUi.style.left = "-35px";
                picture.style.display = "block";
                featuted.style.display = "block";
                img3dButton.style.zIndex = '999999'
                img3d.classList.add('absolute')
                closeImg3d.classList.add('hidden')
                modelViwer.classList.remove('shopify-model-viewer-ui__disabled')
              });
            }


            if (divModel) {
              modelViwer.style.display = "none";
              viewerUi.style.display = "none";
              viewerUi.style.left = "-35px";
              picture.style.display = "block";
              featuted.style.display = "block";
              img3dButton.style.zIndex = '999999'
              img3d.classList.add('absolute')
              closeImg3d.classList.add('hidden')
              modelViwer.classList.remove('shopify-model-viewer-ui__disabled')
            } else {
              modelViwer.style.display = "block";
              viewerUi.style.display = "block";
              viewerUi.style.left = "0";
              picture.style.display = "none";
              featuted.style.display = "none";
              if (img3d.classList.contains('absolute')) {
                // Si la tiene, la eliminamos
                img3d.classList.remove('absolute')
              }
              img3dButton.style.zIndex = '0'
              modelViwer.classList.remove('shopify-model-viewer-ui__disabled')
              if (closeImg3d.classList.contains('hidden')) {
                // Si la tiene, la eliminamos
                closeImg3d.classList.remove('hidden')
              }
              close3d()
            }
          }
        }
      });

      this.addEventListener("mousemove", () => {
        if (isMouseDown) {
          isMouseDown = false;
        }
      });
    }

    loadContent() {
      super.loadContent();

      Shopify.loadFeatures([
        {
          name: "model-viewer-ui",
          version: "1.0",
          onLoad: this.setupModelViewerUI.bind(this),
        },
      ]);
    }

    setupModelViewerUI(errors) {
      if (errors) return;
      this.modelViewerUI = new Shopify.ModelViewerUI(
        this.querySelector("model-viewer")
      );
    }
  }

  customElements.define("product-model", ProductModel);
}

window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: "shopify-xr",
        version: "1.0",
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener("shopify_xr_initialized", () =>
        this.setupShopifyXR()
      );
      return;
    }

    document.querySelectorAll('[id^="product-json-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });

    window.ShopifyXR.setupXRElements();
  },
};

window.addEventListener("DOMContentLoaded", () => {
  if (window.ProductModel) window.ProductModel.loadShopifyXR();
});

// Función para eliminar la clase disabled
function removeDisabledClass() {
  // Seleccionar todos los elementos model-viewer
  const modelViewers = document.querySelectorAll('model-viewer');
  
  modelViewers.forEach(viewer => {
      // Verificar si tiene la clase y eliminarla
      if (viewer.classList.contains('shopify-model-viewer-ui__disabled')) {
          viewer.classList.remove('shopify-model-viewer-ui__disabled');
      }
  });
}
function clickSimulado() {
    
  // Configuración del observador
  const observer = new MutationObserver(function(mutations) {
      
      const img3dButton = document.querySelector('.img-3d .media-poster');
      if (img3dButton) {
        img3dButton.click();
        observer.disconnect(); // Detener el observador después del clic
        console.log('Botón encontrado y clickeado');
      }
  });

  // Comenzar a observar el documento con la configuración descripta
  observer.observe(document.body, {
      childList: true,
      subtree: true
  });

}



// Ejecutar cuando el DOM esté cargado
document.addEventListener('DOMContentLoaded', clickSimulado);
document.addEventListener('DOMContentLoaded', removeDisabledClass);

// Opcional: ejecutar periódicamente para verificar nuevos elementos
setInterval(removeDisabledClass, 1000);



// Función principal para manejar la visibilidad
function handleVisibility() {
  const firstDotButton = document.querySelector('.media-ctrl__pagination button[data-slide-dot="1"]');
  const img3dElement = document.querySelector('.img-3d');
  
  if (!firstDotButton || !img3dElement) return;

  if (!firstDotButton.classList.contains('is-active')) {
    img3dElement.style.display = 'none';
  } else {
    img3dElement.style.display = 'block';
  }
}

// Ejecutar inmediatamente
handleVisibility();

// Observar cambios en los botones de paginación
const paginationContainer = document.querySelector('.media-ctrl__pagination');
if (paginationContainer) {
  const observer = new MutationObserver(handleVisibility);
  
  observer.observe(paginationContainer, {
    attributes: true,
    attributeFilter: ['class'],
    subtree: true,
    childList: true
  });
}

// Opcional: Agregar listener para eventos personalizados si es necesario
document.addEventListener('sliderChanged', handleVisibility);
